<div class="d-flex flex-column align-items-center justify-content-center py-plus">
  <div class="gradiant-bg">
    <common-icon-dp-icon
      [icon]="'gift'"
      [iconSize]="'32'"
    ></common-icon-dp-icon>
  </div>
  <span class="st-7 pt-minus">دوستانت رو دعوت کن و سکه بگیر!</span>
  <p class="l-3 text-onback-medium py-tiny description text-align-center">
    همین الان کد معرفت و از تنظیمات اپلیکیشن کپی و برای دوستانت ارسال کن تا موقع ورود با کد معرفت وارد شوند
  </p>
  <div class="d-flex align-items-center gap-tiny">
    <span class="icon-coin"></span>
    <div>
      <span class="text-onback-brand st-3">۳۰ سکه</span>
    </div>
  </div>
</div>
